import apiCall from '../utils/api';

export const getUser = async () => {
  const url = `/ums/v1/users/profile`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url,
    extraPayload: {
      isFlightPath: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const refreshToken = async () => {
  const url = `/ums/v1/auth/refresh/cookies`;
  const apiArgs = {
    API_CALL: {
      method: 'POST'
    },
    url,
    extraPayload: {
      isFlightPath: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const generateLoginOtp = async (values) => {
  const { email, phoneNumber, isdCode, type, captchaToken, locale } = values;
  const url = `/ums/v2/auth/generate-otp/signin?locale=${locale}`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        email,
        phoneNumber,
        isdCode,
        type,
        recaptcha: captchaToken,
        fallback: false
      }
    },
    url,
    extraPayload: {
      errorResponseRequired: true,
      isFlightPath: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const otpLogin = async (data) => {
  const url = `/ums/v1/auth/validate-otp/signin`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data
    },
    url,
    extraPayload: {
      errorResponseRequired: true,
      isFlightPath: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const logoutUser = async () => {
  const url = `/ums/v1/auth/logout`;
  const apiArgs = {
    API_CALL: {
      method: 'POST'
    },
    url,
    extraPayload: {
      isFlightPath: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const generateTreatmentPlanApprovalOtp = async (values) => {
  const { email, phoneNumber, isdCode, type, recaptcha } = values;
  const url = `/ums/v2/auth/generate-otp/approval`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        email,
        phoneNumber,
        isdCode,
        type,
        recaptcha,
        fallback: false
      }
    },
    url,
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const validateTreatmentPlanOtp = async (data) => {
  const url = `/ums/v1/auth/validate-otp/approval`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: { ...data, fallback: false }
    },
    url,
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};
